export const MAPBOX_ACCESS_TOKEN =
    'pk.eyJ1IjoicXVpY2tseXdpbGxpYW0iLCJhIjoiY21qYWZ2dDB2MDU4bTNlb29zejQ4dWd0bCJ9.EAPb-xXyNRAHnRriAD6YzA';

export const HEATMAP_COLORS = [
    '#FFDDC0',
    '#F9BC88',
    '#E7779F',
    '#EB5190',
    '#B352F3',
    '#7E18CF',
    '#49058C'
];
